import { createSelector } from 'reselect'
import getMerchandiseItems from '../items/getMerchandiseItems'
import getMerchandiseShippingItems from '../items/getMerchandiseShippingItems'
import { isNonNullable } from 'lib/array/arrayUtils'

const getMerchandiseItemViews = createSelector(
  (state: App.State) => getMerchandiseItems(state),
  (state: App.State) => getMerchandiseShippingItems(state),
  (state: App.State) => state.merchandise.merchandise,
  (state: App.State) => state.merchandise.merchandiseShipping,
  (state: App.State) => state.merchandise.merchandiseShippingQuotes,
  (items, shippingItems, merchandise, shipping, shippingQuotes): App.WithDataStatus<Array<App.Checkout.MerchandiseItemView>> => {
    const views = items.map((item): App.Checkout.MerchandiseItemView | undefined => {
      const offer = merchandise[item.advertId]
      const variant = offer?.variants.find((variant) => variant.id === item.variantId)

      const shippingItem = shippingItems.find((si) => si.shippingId === item.shippingId)

      if (!offer || !variant || !shippingItem) {
        return undefined
      }

      // Find the server's shippingGroupId from shipping quotes
      const shippingGroup = shippingQuotes?.shippingGroups.find(group =>
        group.items.some(groupItem => groupItem.itemId === item.itemId),
      )
      const shippingGroupId = shippingGroup?.shippingGroupId ?? shippingItem.itemId

      return {
        title: offer.name,
        item,
        offer,
        variant,
        shipping: shipping[item.variantId],
        shippingItem,
        shippingGroupId,
        loyalty: {
          productType: variant.loyalty.productType,
          earnKey: variant.loyalty.earnKey,
        },
        totals: {
          price: variant.price ?? 0,
          memberPrice: 0,
          value: variant.price ?? 0,
          memberValue: 0,
          surcharge: 0,
          extraGuestSurcharge: 0,
          taxesAndFees: 0,
        },
      }
    }).filter(isNonNullable)

    return {
      hasRequiredData: items.length === views.length,
      data: views,
    }
  },
)

export default getMerchandiseItemViews
